import { Panel } from '../common/Panel';
import { Skeleton } from '../ui/skeleton';

/** Placeholder for a Plan panel while its data loads. */
export function PanelSkeleton({ title, rows = 3 }: { title: string; rows?: number }) {
  return (
    <Panel title={title}>
      <div className="space-y-3">
        {Array.from({ length: rows }, (_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: static placeholder rows
          <div key={i} className="flex items-center justify-between gap-3">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-4 w-16" />
          </div>
        ))}
      </div>
    </Panel>
  );
}
